import { Container, Box, Typography } from '@mui/material';

export default function TermosUso() {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <Box>
        <Typography variant="h4" component="h1" gutterBottom>
          Termos de Uso – Better Lanches
        </Typography>

        <Typography variant="body1" paragraph>
          Estes Termos de Uso regulam a utilização da plataforma de pedidos on-line da Better Lanches ("nós") por parte
          dos usuários ("você"). Ao acessar ou utilizar nossos serviços, você concorda com as condições abaixo.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          1. Objeto
        </Typography>
        <Typography variant="body1" paragraph>
          A Better Lanches disponibiliza uma plataforma para consulta de cardápio, realização de pedidos on-line e envio
          de dados do pedido para estabelecimentos parceiros e canais de comunicação (como WhatsApp) para fins de
          atendimento e entrega.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          2. Uso da plataforma
        </Typography>
        <Typography variant="body1" paragraph>
          Ao utilizar a plataforma, você se compromete a:
        </Typography>
        <Typography variant="body1" component="div" sx={{ pl: 2 }}>
          <ul>
            <li>Fornecer informações verdadeiras, completas e atualizadas.</li>
            <li>Não utilizar o serviço para fins ilícitos, abusivos ou em violação à legislação aplicável.</li>
            <li>Não tentar acessar áreas ou sistemas sem autorização, nem comprometer a segurança da plataforma.</li>
          </ul>
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          3. Pedidos, preços e pagamentos
        </Typography>
        <Typography variant="body1" paragraph>
          Os preços, taxas e condições de pagamento exibidos na plataforma são de responsabilidade dos
          estabelecimentos parceiros. A confirmação do pedido pode depender de disponibilidade de estoque, horário de
          funcionamento e outras condições dos estabelecimentos. Eventuais divergências de preço ou condições serão
          tratadas diretamente com o estabelecimento responsável.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          4. Entrega e responsabilidade
        </Typography>
        <Typography variant="body1" paragraph>
          O prazo de entrega é estimado e pode variar conforme logística, endereço e demanda. A responsabilidade pela
          preparação dos itens e pela entrega é do estabelecimento parceiro e/ou de seus entregadores. Caso ocorra
          atraso, problemas com a qualidade do produto ou erros no pedido, você poderá entrar em contato pelos canais
          de atendimento indicados.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          5. Comunicações
        </Typography>
        <Typography variant="body1" paragraph>
          Ao informar seu número de telefone, você autoriza o envio de comunicações relacionadas ao pedido
          (confirmação, status, dúvidas, etc.), inclusive por WhatsApp. Você pode solicitar o encerramento de
          comunicações não essenciais a qualquer momento.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          6. Propriedade intelectual
        </Typography>
        <Typography variant="body1" paragraph>
          Todos os direitos sobre a plataforma, seu design, marcas, logotipos e conteúdos pertencem à Better Lanches ou a
          seus licenciantes. É proibida a reprodução, modificação, distribuição ou uso não autorizado de qualquer
          parte da plataforma, exceto se expressamente permitido.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          7. Limitação de responsabilidade
        </Typography>
        <Typography variant="body1" paragraph>
          Na máxima extensão permitida pela legislação aplicável, a Better Lanches não se responsabiliza por
          indisponibilidades temporárias da plataforma por motivos de manutenção, problemas técnicos ou força maior,
          nem por danos decorrentes de uso indevido da plataforma pelo usuário. A responsabilidade por produtos,
          prazos, qualidade de itens e entrega é do estabelecimento parceiro.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          8. Privacidade e dados pessoais
        </Typography>
        <Typography variant="body1" paragraph>
          O tratamento dos seus dados pessoais é regido pela nossa Política de Privacidade, disponível em nossa
          página de Política de Privacidade. Ao utilizar nossos serviços, você declara ter lido e concordado com essa
          política.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          9. Alterações destes termos
        </Typography>
        <Typography variant="body1" paragraph>
          Podemos alterar estes Termos de Uso a qualquer momento. A versão atualizada estará sempre disponível nesta
          página. O uso continuado da plataforma após a publicação das alterações será considerado como aceitação dos
          novos termos.
        </Typography>

        <Typography variant="h6" component="h2" gutterBottom>
          10. Contato
        </Typography>
        <Typography variant="body1" paragraph>
          Em caso de dúvidas sobre estes Termos de Uso, entre em contato:
        </Typography>
        <Typography variant="body1" component="div" sx={{ pl: 2 }}>
          <ul>
            <li>E-mail: contato@betterdog.com.br</li>
            <li>Telefone/WhatsApp: (48) 99219-8889</li>
            <li>Endereço: Avenida Irere, Vilage Dunas - Balneário Gaivota/SC</li>
          </ul>
        </Typography>

        <Typography variant="body2" color="text.secondary" sx={{ mt: 4 }}>
          Data da última atualização: 15/12/2025
        </Typography>
      </Box>
    </Container>
  );
}
